<template>
    <div>
    <div v-if='current.matches("mode.home")' class='row' >
        <div class='col-sm-12' id='header-image-container'>
        <img class='header-image'  src="/assets/Uploads/AtHome-Header-ONLINE.jpg" alt="@hOMe - Lockdown distractions are just a click away!" width="1167" height="311">
        </div>
    </div>
    <h2 v-if='current.matches("mode.tag")' >{{query.tag}}</h2>
    <div class='row'>

    <teddy-bear></teddy-bear>
    <transition-group v-if='resources.length > 0' name="list" tag='div' class='resourceTiles'>
        <component :is='componentType(resource)' v-for='resource in resources' :key='resource.id' :resource='resource'></component>
    </transition-group> 

    <div v-if='current.matches("loading.loading")'>
        <loading-spinner></loading-spinner>
    </div>

    <input v-if='current.matches("loading.loaded")' class='btn-loadmore cs-cerulean' type='button' @click='loadMore' value='Load More'>
    </div>
    </div>
</template>

<script>
import axios from 'axios'
import YouTubeTile from '../components/YouTubeTile'
import PdfTile from '../components/PdfTile'
import PageTile from '../components/PageTile'
import ContentTile from '../components/ContentTile'
import EmbedTile from '../components/EmbedTile'
import TeddyBear from '../components/TeddyBear'
import EasterEgg from '../components/EasterEgg'
import LoadingSpinner from '../components/LoadingSpinner'
import _ from 'lodash'
import { createMachine, interpret } from "xstate";
            
const stateMachine = createMachine({
    id: 'resourceSearchState',
    type: 'parallel',
    states: {
        loading: {
            initial: 'loading',
            states: {
                loading: {
                    on: { SWITCH_LOADED: 'loaded' }
                },
                loaded: {
                    on: { SWITCH_LOADING: 'loading' }
                }
            }
        },
        mode: {
            initial: 'home',
            states: {
                home: {
                    on: { SWITCH_TAG: 'tag' },
                },
                tag: {
                    on: { SWITCH_HOME: 'home' }
                }
            }
        }
    }
});

let types = {
    'Page': 'page-tile',
    'PDF': 'pdf-tile',
    'YouTube': 'youtube-tile',
    'Content': 'content-tile',
    'Embed': 'embed-tile'
}

export default {
    name: 'resource',
    props: ['query'],
    data() {
        return {
            current: stateMachine.initialState,
            resources: [],
            stateService: interpret(stateMachine),
        }
    },
    methods: {
        componentType(resource) {
            return types[resource.type];
        },
        refresh() {
            this.stateService.send('SWITCH_LOADING');

            if (!_.isEmpty(this.query)) {
                let query = JSON.stringify({tag: this.query.tag});
                this.stateService.send('SWITCH_TAG');

                axios.get(`${this.$api}/resource/search?query=${query}`).then(result => {
                    this.resources = result.data;
                    this.stateService.send('SWITCH_LOADED');
                    this.$eventBus.$emit('resources-loaded');
                });
            } else {
                let query = JSON.stringify({tag: 'Featured'});
                this.stateService.send('SWITCH_HOME');

                axios.get(`${this.$api}/resource/search`).then(result => {
                    this.resources = result.data;
                    this.stateService.send('SWITCH_LOADED');
                    this.$eventBus.$emit('resources-loaded');
                });
            }
        },
        loadMore() {
            let query;

            this.stateService.send('SWITCH_LOADING');

            if (this.query) {
                query = JSON.stringify({tag: this.query.tag, offset: this.resources.length });
            } else {
                query = JSON.stringify({ offset: this.resources.length });
            }

            axios.get(`${this.$api}/resource/search?query=${query}`).then(result => {
                this.resources = this.resources.concat(result.data);
                this.stateService.send('SWITCH_LOADED');
                this.$eventBus.$emit('resources-loaded');
            });
        }
    },  
    watch: {
        '$route': function() {
            this.refresh();
        }
    },
    created() {
        this.stateService
            .onTransition(state => {
                this.current = state;
            })
            .start();

        this.refresh();
    },
    components: {
        'page-tile': PageTile,
        'pdf-tile': PdfTile,
        'youtube-tile': YouTubeTile,
        'content-tile': ContentTile,
        'embed-tile': EmbedTile,
        'teddy-bear': TeddyBear,
        'easter-egg': EasterEgg,
        'loading-spinner': LoadingSpinner
    }
}
</script>

<style lang="less">
#header-image-container {
    padding-left: 0;
}

.header-image {
    margin-bottom: 20px;
    height: auto;
}

.btn-loadmore {
    border: none;
    color: white;
    padding: 5px 40px;
    font-weight: bold;
    text-transform: uppercase;
    text-align: center;
    align-self: center;
    margin: 0 auto;
    display: flex;
}

.resourceTiles {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
}

.resourceTilesVertical {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.resourceTiles::after {
    content: "";
    flex: auto;
}

.resourceTile {
    position: relative;
    min-height: 268px; // 325px;
    flex-basis: 23.5%;
    margin-bottom: 1.5%;
    margin-right: 1.5%;
    display: flex;

    img {
        display: block;
        width: 100%;
    }

    .resourceTileInner {
        width: 100%;
    }

    .resourceType {
        position: absolute;
        top: 10px;
        right: 10px;
        width: 24px;
    }


    .resourceText {
        bottom: 0;
        color: white;
        padding: 20px;
        width: 100%;
        box-sizing: border-box;
        text-transform: uppercase;
        font-weight: bold;
        font-size: 8px;
        position: absolute;
    }

    .resourceTags {
        position: absolute;
        bottom: 2px;
        right: 5px;
    }

    .tag {
        font-size: 10px;
        color: white;
        font-weight: bold;
        text-transform: uppercase;
        margin-right: 5px;
        padding-right: 5px;
        border-right: 1px solid white;
        text-decoration: underline;
    }

    .tag:last-child {
        padding-right: 0;
        border-right: 0;
    }
}

@media only screen and (max-width: 1200px) {
    .resourceTiles .resourceTile {
        flex-basis: 31%;
    }
}

@media only screen and (max-width: 980px) {
    .resourceTiles .resourceTile {
        flex-basis: 45%;
        min-height: 40vw;
    }
}

@media only screen and (max-width: 630px) {
    .resourceTiles .resourceTile {
        flex-basis: 45%;
        min-height: 45vw;
        margin-bottom: 15px;
       
        .resourceText {
            padding: 10px;
        }

        h2 {
            font-size: 1.4em;
        }
        
        .tag {
            font-size: 8px;
        }
    }
}
</style>